<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-building"></span>Error Logs</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>
  <div class="content">

    <div class="margin-top-16">
      <p-table #errorsTable [value]="errorLogs" [rows]="limit">
        <ng-template pTemplate="caption">
          <div class="row justify-content-start mb-2">
            <div class="col-3 d-flex">
              <input type="text" pInputText size="50" placeholder="Search by trace reference" [(ngModel)]="search"
                (input)="onSearchInput()" style="width:auto">
              <i class="fa fa-search mt-2" style="margin-left: -30px" (click)="searchErrorLog()"></i>
            </div>
            <div class="col-6"></div>
            <div class="col-3 d-flex justify-content-end">
              <button pButton class="full-width" label="Test Error Modal" [disabled]="loadingTestErrorModal"  (click)="testErrorModal()"></button>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 180px;">Trace</th>
            <th style="width: 180px;">Username</th>
            <th style="width: 180px;">Date (UTC)</th>
            <th style="width: 320px;">Message</th>
            <th style="width: 50px;"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-error>
          <tr>
            <td>{{ error.traceReference }}</td>
            <td>{{ error.username }}</td>
            <td>{{ error.date }}</td>
            <td title="{{ error.errorMessage }}">{{ error.errorMessage }}</td>
            <td>
              <div pTooltip="View error details" tooltipPosition="left" class="fa hubtiger-edit font-button"
                (click)="viewErrorLog(error)">
              </div>
            </td>
          </tr>
        </ng-template>

      </p-table>
      <!-- Optional paginator, can uncomment when needed -->
      <p-paginator #paginator [rows]="limit" [totalRecords]="totalRecords"
        (onPageChange)="paginate($event)"></p-paginator>
    </div>

  </div>
</div>
